import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
// Import Icon
import ChevronUp from "../../assets/icons/chevron-up-outline.svg";
import ChevronDown from "../../assets/icons/chevron-down-outline.svg";
const Sidebar = () => {
  const location = useLocation();
  const [marketingCollapse, setMarketingCollapse] = useState(false);
  const [financeCollape, setFinanceCollapse] = useState(false);
  const [reportCollapse, setReportCollapse] = useState(false);
  const [locationUrl, setLocaltionUrl] = useState(location.pathname);
  const HanddleMarketing = () => {
    setMarketingCollapse(true);
  };
  const HanddleFinance = () => {
    setFinanceCollapse(true);
  };
  const HanddleReport = () => {
    setReportCollapse(true);
  };

  useEffect(() => {
    setLocaltionUrl(location.pathname);
    if (locationUrl === "/banner" || locationUrl === "/notification") {
      HanddleMarketing();
    }
    if (locationUrl === "/withdraw" || locationUrl === "/account") {
      HanddleFinance();
    }
    if (locationUrl === "/sales" || locationUrl === "/purchases") {
      HanddleReport();
    }
  }, [location]);
  return (
    <>
      <div className="fixed flex flex-col max-w-xs shadow-xl pt-4 w-2/12 h-screen bg-white z-20">
        <div className="flex flex-col text-font-gray-light w-8/12 mx-auto ">
          <Link
            to="/homepage"
            className="tracking-0-78 font-atten text-2xl italic leading-none"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="160"
              height="80"
              viewBox="0 0 200.481 92.227"
            >
              <path
                d="M5.913,107.654c3.483,0,6.257-1.944,6.257-5.427,0-3.078-2.268-4.415-4.779-5.468-1.944-.81-3.787-1.4-3.787-3,0-1.134.992-2.126,2.795-2.126a8.644,8.644,0,0,1,4.86,1.681l-.425-3.625A11.055,11.055,0,0,0,6.5,88.74c-3.848,0-6.116,2.167-6.116,5.2,0,2.936,2,4.253,5,5.508,1.924.83,3.584,1.4,3.584,2.977,0,1.377-1.195,2.329-3.017,2.329A9.3,9.3,0,0,1,0,102.227l.344,3.726a9.792,9.792,0,0,0,5.569,1.7Zm12.96-3.119v-5h6.885V96.759H18.874v-4.84h7.938l-.547-2.9H15.633v18.408H26.508l.567-2.9h-8.2Zm26.144,3.038h1.235V89.024H43.073l.041,11.988h-.041L31.935,88.882H30.518v18.55h3.2L33.7,95.159h.041l11.28,12.414Zm18.955-18.55H49.148v2.9H54.96v15.512H58.2V91.919h5.771v-2.9ZM77.6,107.431h3.888l-5.65-7.614a5.523,5.523,0,0,0,3.382-5.144c0-3.078-2.228-5.65-6.48-5.65H66.868v18.408h3.26v-6.926h2.491l4.982,6.926ZM70.128,91.919h2.43c1.944,0,3.3.992,3.3,2.957,0,1.863-1.3,2.9-3.362,2.9H70.128V91.919Zm25.536,15.512h3.382l-8.2-18.55H89.508l-8.181,18.55h3.382l1.8-4.334h7.371l1.782,4.334Zm-8.019-7.067,2.511-6.1h.061l2.511,6.1H87.645Zm29.687-2.43a4.556,4.556,0,0,0,2.369-4.07c0-3.038-2.329-4.84-5.589-4.84h-5.67v18.408H114.7c3.422,0,5.751-2.086,5.751-5.123a4.618,4.618,0,0,0-3.119-4.374Zm-3.281-7.108c2.309,0,3.686,1.175,3.686,3.058a3.167,3.167,0,0,1-3.5,3.321h-3.787V90.826Zm.466,14.8h-4.07V98.967h4.07c2.531,0,3.868,1.3,3.868,3.321C118.385,104.292,117.049,105.629,114.517,105.629Zm12.13,0V89.024h-2v18.408H134.1l.344-1.8Zm23.207,1.8h2.086l-7.878-18.55h-.871l-7.918,18.55h2.086l2.288-5.447h7.938l2.268,5.447ZM140.4,100.2l3.2-7.655h.02l3.2,7.655H140.4Zm28.614,7.351h.851V89.023H167.9V103.3h-.061L155.95,88.9H155v18.529h1.944V92.972H157l12.009,14.58Zm9.963-4.617c0,2.147-1.175,2.9-2.653,2.9a5.076,5.076,0,0,1-3.1-1.3l.3,2.268a5.362,5.362,0,0,0,2.876.911,4.38,4.38,0,0,0,4.577-4.678V89.024h-2v13.912Zm19.42,4.5h2.086l-7.9-18.55h-.851l-7.918,18.55H185.9l2.268-5.447h7.938l2.288,5.447Zm-9.457-7.229,3.2-7.655h.02l3.2,7.655h-6.419Z"
                transform="translate(0 -15.488)"
                fill="#596375"
              />
              <g transform="translate(69.5)">
                <path
                  d="M44.268,0A30.528,30.528,0,1,1,13.74,30.528,30.528,30.528,0,0,1,44.268,0Zm0,9.706A20.821,20.821,0,1,1,23.446,30.528,20.822,20.822,0,0,1,44.268,9.706Z"
                  transform="translate(-13.74)"
                  fill="#f86542"
                  fill-rule="evenodd"
                />
                <path
                  d="M46.915,18.09A15.085,15.085,0,1,1,31.83,33.175,15.083,15.083,0,0,1,46.915,18.09Z"
                  transform="translate(-16.387 -2.647)"
                  fill="#f86542"
                  fill-rule="evenodd"
                />
              </g>
            </svg>
          </Link>
        </div>
        <div className="flex-grow overflow-y-auto">
          <div className="mt-10 w-full flex flex-col">
            <p className=" text-line-orange font-light w-8/12 mx-auto">Utama</p>
            <Link
              to="/backoffice"
              className={
                "flex py-3 hover:bg-orange-100 menu-sidebar border-l-2 " +
                (locationUrl === "/backoffice"
                  ? " border-l-2 border-orange-500 text-basic-orange bg-orange-100 icon-active"
                  : " border-l-2 border-transparent")
              }
            >
              <span className="flex items-center  mx-auto w-8/12 ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22.5"
                  height="22.5"
                  viewBox="0 0 22.5 22.5"
                >
                  <g
                    id="Icon_ionic-md-speedometer"
                    data-name="Icon ionic-md-speedometer"
                    transform="translate(-3.125 -3.125)"
                  >
                    <path
                      id="Path_1308"
                      data-name="Path 1308"
                      d="M9,29.25H24.364v1.991H9Z"
                      transform="translate(-2.307 -5.866)"
                      fill="#596375"
                      // fill="#F68906"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                    <path
                      id="Path_1309"
                      data-name="Path 1309"
                      d="M15.707,17.034a1.327,1.327,0,1,0-.365-2.6l-2.766-2.02-.166.145,2.028,2.766a1.3,1.3,0,0,0-.058.386A1.326,1.326,0,0,0,15.707,17.034Z"
                      transform="translate(-1.703 -1.703)"
                      fill="#596375"
                      // fill="#F68906"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                    <path
                      id="Path_1310"
                      data-name="Path 1310"
                      d="M14.375,3.375c-6.076,0-11,5.177-11,11.565a11.894,11.894,0,0,0,2.332,7.117h3.11l.212-.222L10.2,20.606,8.986,19.333,7.817,20.556A9.11,9.11,0,0,1,5.956,15.83h1.65V14.051H5.956A9.11,9.11,0,0,1,7.817,9.324l1.169,1.223L10.2,9.274,9.034,8.046a8.216,8.216,0,0,1,4.5-1.957V7.823h1.692V6.088a8.216,8.216,0,0,1,4.5,1.957L18.553,9.274l1.211,1.273,1.169-1.223a9.11,9.11,0,0,1,1.862,4.726h-1.65V15.83h1.65a9.11,9.11,0,0,1-1.862,4.726l-1.169-1.223-1.211,1.273,1.169,1.229.212.222h3.11a11.894,11.894,0,0,0,2.332-7.117C25.375,8.552,20.451,3.375,14.375,3.375Z"
                      transform="translate(0 0)"
                      fill="#596375"
                      // fill="#F68906"
                      stroke="#fff"
                      strokeWidth="0.5"
                    />
                  </g>
                </svg>

                <p className="ml-4">Dashboard</p>
              </span>
            </Link>
            <Link
              to="/transaction"
              className={
                "flex py-3 hover:bg-orange-100 menu-sidebar border-l-2 " +
                (locationUrl === "/transaction"
                  ? " border-l-2 border-orange-500 text-basic-orange bg-orange-100 icon-active"
                  : " border-l-2 border-transparent")
              }
            >
              <span className="flex items-center mx-auto w-8/12">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21.833"
                  height="19.375"
                  viewBox="0 0 21.833 19.375"
                >
                  <path
                    id="Icon_open-transfer"
                    data-name="Icon open-transfer"
                    d="M15.75,0V2.625H0V5.25H15.75V7.875L21,3.938ZM5.25,10.5,0,14.438l5.25,3.938V15.75H21V13.125H5.25Z"
                    transform="translate(0.417 0.5)"
                    fill="#596375"
                    stroke="#fff"
                    strokeWidth="0.5"
                  />
                </svg>

                <p className="ml-4">Transaksi</p>
              </span>
            </Link>
            <Link
              to="/merchandise"
              className={
                "flex py-3 hover:bg-orange-100 menu-sidebar border-l-2 " +
                (locationUrl === "/merchandise"
                  ? " border-l-2 border-orange-500 text-basic-orange bg-orange-100 icon-active"
                  : " border-l-2 border-transparent")
              }
            >
              <span className="flex items-center mx-auto w-8/12">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22.939"
                  height="19.346"
                  viewBox="0 0 22.939 19.346"
                >
                  <path
                    id="Icon_simple-marketo"
                    data-name="Icon simple-marketo"
                    d="M15.8,0V22l5.623-4.479V3.056ZM13.189,17.195,8.662,19.172V1.912l4.527,1.34ZM2.582,16.688l3.465-.916V4.756L2.6,4.2Z"
                    transform="translate(22.519 -2.331) rotate(90)"
                    fill="#596375"
                    stroke="#fff"
                    strokeWidth="0.5"
                  />
                </svg>

                <p className="ml-4">Produk</p>
              </span>
            </Link>
          </div>
          <div className="mt-8 w-full flex flex-col">
            <p className=" text-line-orange font-light w-8/12 mx-auto">User</p>
            <Link
              to="/customer"
              className={
                "flex py-3 hover:bg-orange-100 menu-sidebar border-l-2 " +
                (locationUrl === "/customer"
                  ? " border-orange-500 text-basic-orange bg-orange-100 icon-active"
                  : " border-transparent")
              }
            >
              <span className="flex items-center mx-auto w-8/12">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="14"
                  viewBox="0 0 22 14"
                >
                  <path
                    id="Icon_material-people-outline"
                    data-name="Icon material-people-outline"
                    d="M17,15.5a11.987,11.987,0,0,0-4.5,1,11.8,11.8,0,0,0-4.5-1c-2.17,0-6.5,1.08-6.5,3.25V21.5h22V18.75C23.5,16.58,19.17,15.5,17,15.5ZM13,20H3V18.75C3,18.21,5.56,17,8,17s5,1.21,5,1.75Zm9,0H14.5V18.75a1.819,1.819,0,0,0-.52-1.22A9.647,9.647,0,0,1,17,17c2.44,0,5,1.21,5,1.75ZM8,14.5A3.5,3.5,0,1,0,4.5,11,3.5,3.5,0,0,0,8,14.5ZM8,9a2,2,0,1,1-2,2A2.006,2.006,0,0,1,8,9Zm9,5.5A3.5,3.5,0,1,0,13.5,11,3.5,3.5,0,0,0,17,14.5ZM17,9a2,2,0,1,1-2,2A2.006,2.006,0,0,1,17,9Z"
                    transform="translate(-1.5 -7.5)"
                    fill="#596375"
                  />
                </svg>
                <p className="ml-4">Konsumen</p>
              </span>
            </Link>
            <div
              className={
                "flex py-3 hover:bg-orange-100 menu-sidebar border-l-2 border-transparent cursor-pointer"
              }
              onClick={() => setMarketingCollapse(!marketingCollapse)}
            >
              <span className="flex items-center mx-auto w-8/12">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22.5"
                  height="18.1"
                  viewBox="0 0 22.5 18.1"
                >
                  <path
                    id="Icon_awesome-project-diagram"
                    data-name="Icon awesome-project-diagram"
                    d="M13.2,11H8.8a1.1,1.1,0,0,0-1.1,1.1v4.4a1.1,1.1,0,0,0,1.1,1.1h4.4a1.1,1.1,0,0,0,1.1-1.1V12.1A1.1,1.1,0,0,0,13.2,11ZM6.6,1.1A1.1,1.1,0,0,0,5.5,0H1.1A1.1,1.1,0,0,0,0,1.1V5.5A1.1,1.1,0,0,0,1.1,6.6H4.39L6.905,11A2.193,2.193,0,0,1,8.8,9.9h.01L6.6,6.033V4.4h7.7V2.2H6.6ZM20.9,0H16.5a1.1,1.1,0,0,0-1.1,1.1V5.5a1.1,1.1,0,0,0,1.1,1.1h4.4A1.1,1.1,0,0,0,22,5.5V1.1A1.1,1.1,0,0,0,20.9,0Z"
                    transform="translate(0.25 0.25)"
                    fill="#596375"
                    stroke="#fff"
                    strokeWidth="0.5"
                  />
                </svg>
                <p className="ml-4">Marketing</p>
                <div className="h-4 ml-auto ">
                  {marketingCollapse ? (
                    <img alt="Marketing Chevron Up" className="h-4 ml-auto mt-1" src={ChevronUp} />
                  ) : (
                    <img
                      alt="Marketing Chevron Down"
                      className="h-4 ml-auto mt-1"
                      src={ChevronDown}
                    />
                  )}
                </div>
              </span>
            </div>

            {marketingCollapse && (
              <div class="bg-gray-100 flex flex-col">
                <Link
                  to="/banner"
                  className={
                    " border-l-2 py-3  text-gray-600 bg-white hover:bg-orange-100 menu-sidebar" +
                    (locationUrl === "/banner"
                      ? " border-orange-500 text-basic-orange bg-orange-100 icon-active"
                      : " border-transparent")
                  }
                >
                  <p class=" px-16 block text-md">Banner</p>
                </Link>
                <Link
                  to="/notification"
                  className={
                    " border-l-2 py-3  text-gray-600 bg-white hover:bg-orange-100 menu-sidebar" +
                    (locationUrl === "/notification"
                      ? " border-orange-500 text-basic-orange bg-orange-100 icon-active"
                      : " border-transparent")
                  }
                >
                  <p class="px-16 block text-md ">Notifikasi</p>
                </Link>
              </div>
            )}
          </div>
          <div className="mt-8 w-full flex flex-col">
            <p className=" text-line-orange font-light w-8/12 mx-auto">
              Administrasi
            </p>

            <div
              className={
                "flex py-3 hover:bg-orange-100 menu-sidebar border-l-2 order-transparent cursor-pointer"
              }
              onClick={() => setFinanceCollapse(!financeCollape)}
            >
              <span className="flex items-center mx-auto w-8/12">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="12.48"
                  viewBox="0 0 24 12.48"
                >
                  <path
                    id="Icon_map-finance"
                    data-name="Icon map-finance"
                    d="M20.64,8.64H0V21.12H24V8.64Zm2.4,9.25a3.216,3.216,0,0,0-2.27,2.27H3.23A3.217,3.217,0,0,0,.96,17.89V11.87A3.217,3.217,0,0,0,3.23,9.6H20.781a3.363,3.363,0,0,0,2.259,2.259V17.89ZM13.016,15.866c-.11-.067-.056-.129-.536-.186v1.391l.263-.049a.7.7,0,0,0,.535-.7A.514.514,0,0,0,13.016,15.866ZM10.855,13.6a.515.515,0,0,0,.291.48,1.942,1.942,0,0,0,.373.139V12.9a1.149,1.149,0,0,0-.369.151A.62.62,0,0,0,10.855,13.6ZM12,10.08a4.579,4.579,0,0,0-4.32,4.8A4.579,4.579,0,0,0,12,19.68a4.579,4.579,0,0,0,4.32-4.8A4.579,4.579,0,0,0,12,10.08Zm1.85,7.514a2.847,2.847,0,0,1-1.37.513v.613h-.96V18.1a2.469,2.469,0,0,1-1.242-.4A1.786,1.786,0,0,1,9.6,16.32h1.194c.039,0,.115.384.228.52s.285.156.5.215V15.421a3.831,3.831,0,0,1-1.217-.437,1.46,1.46,0,0,1-.605-1.3,1.72,1.72,0,0,1,.592-1.336,2.195,2.195,0,0,1,1.23-.5v-.81h.96v.835a2.356,2.356,0,0,1,1.1.516,1.571,1.571,0,0,1,.79,1.528h-1.2a.9.9,0,0,0-.563-.839.978.978,0,0,1-.128-.1V14.49l.433.084a3.142,3.142,0,0,1,1.116.434,1.44,1.44,0,0,1,.5,1.223,1.756,1.756,0,0,1-.674,1.363Z"
                    transform="translate(0 -8.64)"
                    fill="#596375"
                  />
                </svg>
                <p className="ml-4">Keuangan</p>
                <div className="h-4 ml-auto ">
                  {financeCollape ? (
                    <img alt="Chevron Up Keuangan" className="h-4 ml-auto mt-1" src={ChevronUp} />
                  ) : (
                    <img alt="Chevron Down Keuangan"  className="h-4 ml-auto mt-1" src={ChevronDown} />
                  )}
                </div>
              </span>
            </div>

            {financeCollape && (
              <div class="bg-gray-100 flex flex-col">
                <Link
                  to="/withdraw"
                  className={
                    " border-l-2 py-3  text-gray-600 bg-white hover:bg-orange-100 menu-sidebar" +
                    (locationUrl === "/withdraw"
                      ? " border-orange-500 text-basic-orange bg-orange-100 icon-active"
                      : " border-transparent")
                  }
                >
                  <p class=" px-16 block text-md ">Penarikan</p>
                </Link>
                <Link
                  to="/account"
                  className={
                    " border-l-2 py-3  text-gray-600 bg-white hover:bg-orange-100 menu-sidebar " +
                    (locationUrl === "/account"
                      ? " border-orange-500 text-basic-orange bg-orange-100 icon-active"
                      : " border-transparent")
                  }
                >
                  <p class="pl-16 pr-10 block text-md">Akun keuangan</p>
                </Link>
              </div>
            )}

            <div
              className={
                "flex py-3 hover:bg-orange-100 menu-sidebar border-l-2 border-transparent cursor-pointer"
              }
              onClick={() => setReportCollapse(!reportCollapse)}
            >
              <span className="flex items-center mx-auto w-8/12">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.3"
                  height="22.5"
                  viewBox="0 0 20.3 22.5"
                >
                  <path
                    id="Icon_material-date-range"
                    data-name="Icon material-date-range"
                    d="M11.1,12.9H8.9v2.2h2.2Zm4.4,0H13.3v2.2h2.2Zm4.4,0H17.7v2.2h2.2Zm2.2-7.7H21V3H18.8V5.2H10V3H7.8V5.2H6.7A2.19,2.19,0,0,0,4.511,7.4L4.5,22.8A2.2,2.2,0,0,0,6.7,25H22.1a2.206,2.206,0,0,0,2.2-2.2V7.4A2.206,2.206,0,0,0,22.1,5.2Zm0,17.6H6.7V10.7H22.1Z"
                    transform="translate(-4.25 -2.75)"
                    fill="#596375"
                    stroke="#fff"
                    strokeWidth="0.5"
                  />
                </svg>

                <p className="ml-4">Laporan</p>
                <div className="h-4 ml-auto ">
                  {reportCollapse ? (
                    <img alt="Laporan chevron up" className="h-4 ml-auto mt-1" src={ChevronUp} />
                  ) : (
                    <img alt="Laporan chevron down" className="h-4 ml-auto mt-1" src={ChevronDown} />
                  )}
                </div>
              </span>
            </div>

            {reportCollapse && (
              <div class="bg-gray-100 flex flex-col">
                <Link
                  to="/sales"
                  className={
                    " border-l-2 py-3  text-gray-600 bg-white hover:bg-orange-100 menu-sidebar" +
                    (locationUrl === "/sales"
                      ? " border-orange-500 text-basic-orange bg-orange-100 icon-active"
                      : " border-transparent")
                  }
                >
                  <p class="px-16 block text-md">Penjualan</p>
                </Link>
                <Link
                  to="/purchases"
                  className={
                    " border-l-2 py-3  text-gray-600 bg-white hover:bg-orange-100 menu-sidebar" +
                    (locationUrl === "/purchases"
                      ? " border-orange-500 text-basic-orange bg-orange-100 icon-active"
                      : " border-transparent")
                  }
                >
                  <p class="px-16 block text-md text-gray-600  ">Pembelian</p>
                </Link>
              </div>
            )}

            <Link
              to="/employee"
              className={
                "flex py-3 hover:bg-orange-100 menu-sidebar border-l-2 " +
                (locationUrl === "/employee"
                  ? " border-orange-500 text-basic-orange bg-orange-100 icon-active"
                  : " border-transparent")
              }
            >
              <span className="flex items-center mx-auto w-8/12">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22.967"
                  height="21.93"
                  viewBox="0 0 22.967 21.93"
                >
                  <path
                    id="Icon_feather-star"
                    data-name="Icon feather-star"
                    d="M13.583,3l3.27,6.625,7.313,1.069-5.292,5.154,1.249,7.281-6.541-3.44L7.043,23.13l1.249-7.281L3,10.694l7.313-1.069Z"
                    transform="translate(-2.1 -2.1)"
                    fill="none"
                    stroke="#475062"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.8"
                  />
                </svg>

                <p className="ml-4">Karyawan</p>
              </span>
            </Link>

            <Link
              to="/setting"
              className={
                "flex py-3 hover:bg-orange-100 menu-sidebar border-l-2 " +
                (locationUrl === "/setting"
                  ? " border-orange-500 text-basic-orange bg-orange-100 icon-active"
                  : " border-transparent")
              }
            >
              <span className="flex items-center mx-auto w-8/12">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  focusable="false"
                  width="1.25em"
                  height="1.25em"
                  style={{ transform: "rotate(360deg)" }}
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 16 16"
                >
                  <g fill="black">
                    <path
                      fillRule="evenodd"
                      d="M8.837 1.626c-.246-.835-1.428-.835-1.674 0l-.094.319A1.873 1.873 0 0 1 4.377 3.06l-.292-.16c-.764-.415-1.6.42-1.184 1.185l.159.292a1.873 1.873 0 0 1-1.115 2.692l-.319.094c-.835.246-.835 1.428 0 1.674l.319.094a1.873 1.873 0 0 1 1.115 2.693l-.16.291c-.415.764.42 1.6 1.185 1.184l.292-.159a1.873 1.873 0 0 1 2.692 1.116l.094.318c.246.835 1.428.835 1.674 0l.094-.319a1.873 1.873 0 0 1 2.693-1.115l.291.16c.764.415 1.6-.42 1.184-1.185l-.159-.291a1.873 1.873 0 0 1 1.116-2.693l.318-.094c.835-.246.835-1.428 0-1.674l-.319-.094a1.873 1.873 0 0 1-1.115-2.692l.16-.292c.415-.764-.42-1.6-1.185-1.184l-.291.159A1.873 1.873 0 0 1 8.93 1.945l-.094-.319zm-2.633-.283c.527-1.79 3.065-1.79 3.592 0l.094.319a.873.873 0 0 0 1.255.52l.292-.16c1.64-.892 3.434.901 2.54 2.541l-.159.292a.873.873 0 0 0 .52 1.255l.319.094c1.79.527 1.79 3.065 0 3.592l-.319.094a.873.873 0 0 0-.52 1.255l.16.292c.893 1.64-.902 3.434-2.541 2.54l-.292-.159a.873.873 0 0 0-1.255.52l-.094.319c-.527 1.79-3.065 1.79-3.592 0l-.094-.319a.873.873 0 0 0-1.255-.52l-.292.16c-1.64.893-3.433-.902-2.54-2.541l.159-.292a.873.873 0 0 0-.52-1.255l-.319-.094c-1.79-.527-1.79-3.065 0-3.592l.319-.094a.873.873 0 0 0 .52-1.255l-.16-.292c-.892-1.64.902-3.433 2.541-2.54l.292.159a.873.873 0 0 0 1.255-.52l.094-.319z"
                    />
                    <path
                      fill-rule="evenodd"
                      d="M8 5.754a2.246 2.246 0 1 0 0 4.492a2.246 2.246 0 0 0 0-4.492zM4.754 8a3.246 3.246 0 1 1 6.492 0a3.246 3.246 0 0 1-6.492 0z"
                    />
                  </g>
                </svg>
                <p className="ml-4">Pengaturan</p>
              </span>
            </Link>
          </div>
        </div>
        <div className="flex border-t border-gray-200 py-8">
          <div className="flex w-8/12 mx-auto items-center ">
            <img
              src="/assets/img/avatar.jpg"
              className="h-12 rounded-full mr-4"
              alt=""
            />
            <div className="flex flex-col">
              <p className="">Stevani</p>
              <p className="text-sm tracking-0-28">Admin</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
